export default {"gitHash":"61ac7d1ea80a30ee06f760234755aed07a69c95a","gitHashShort":"61ac7d1","time":1674701798730,"platform":"linux","arch":"x64"};